<template>
  <v-select
    v-model="fieldValue"
    class="octa-custom-select"
    :options="options"
    label="text"
    :filterable="isSearchableList"
    :searchable="isSearchableList"
    @input="fieldUpdated"
  >
    <template #option="option">
      {{ option.text }}
    </template>

    <template #no-options="">{{ $t('login.fields.noOptions') }}</template>
  </v-select>
</template>

<script>
  import Issue from './emission-field'

  import vSelect from 'vue-select'

  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'ListField',
    components: {
      'v-select': vSelect
    },
    props: {
      id: {
        type: String,
        required: true
      },
      options: {
        type: Array,
        required: true
      },
      value: {
        default: '',
        required: false
      },
      nameFieldType: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        fieldValue: ''
      }
    },
    computed: {
      isSearchableList() {
        return this.nameFieldType === 'SearchableList'
      }
    },
    methods: {
      fieldUpdated(value) {
        this.fieldValue = value

        this.$emit(
          'input',
          Issue.createField(this.id, this.fieldValue.text, true)
        )
      }
    }
  }
</script>
